<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5">
      <!-- Card stats -->
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-body">
              <ModulesTable
              v-model:rerender_key="rerender_key"
              :key="rerender_key"
              >/</ModulesTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import ModulesTable from "./Modules/ModulesTable"
export default {
  components: {
    ModulesTable
  },
  data() {
    return {
      nav: null,
      rerender_key: 0,
    };
  }  
};
</script>
<style></style>